<template>
  <Icon
    :type="deviceModeIcons[avatarType]"
    v-if="avatarType !== null && deviceModeIcons[avatarType]"
    class="device-avatar"
    st
  />
</template>
<script>
import deviceAvatarList from '@/config/deviceAvatar';

export default {
  props: {
    avatarType: {
      type: [Number, null],
      default: null,
    },
  },

  computed: {
    // 设备类型图标(暂时写死6种,后台与是写死，前端Map图标)
    deviceModeIcons() {
      const _iconList = {};
      deviceAvatarList.forEach(item => {
        _iconList[item.value] = item.icon;
      });

      return _iconList;
    },
  },
};
</script>
<style lang="less" scoped>
.device-avatar {
  margin-right: 5px;
  width: 32px;
  height: 32px;
}
</style>
